export{b,c,g as dataVizColors,e,s,t}from"./index-1e08a164.js";import"@mui/material";
